import { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';
import { BarChart2, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function GoogleAnalyticsSettings() {
  const [gaId, setGaId] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/integrations/ga`)
      .then(res => { setGaId(res.data.measurement_id || ''); setEnabled(res.data.enabled || false); })
      .catch(err => console.error(err));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API_URL}/api/integrations/ga`, { measurement_id: gaId, enabled });
      toast.success('Google Analytics settings saved');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  return (
    <Card className="bg-white border-gray-border" data-testid="ga-settings">
      <CardHeader>
        <CardTitle className="text-lg font-heading flex items-center gap-2">
          <BarChart2 className="h-5 w-5 text-emerald-brand" />
          Google Analytics
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-off-white rounded-lg">
          <span className="font-medium text-text-primary">Enable Tracking</span>
          <Switch checked={enabled} onCheckedChange={setEnabled} />
        </div>
        <div>
          <Label>Measurement ID</Label>
          <Input
            placeholder="G-XXXXXXXXXX"
            value={gaId}
            onChange={(e) => setGaId(e.target.value)}
            className="mt-2"
            data-testid="ga-measurement-id"
          />
          <p className="text-xs text-gray-medium mt-1">Find this in your GA4 property settings</p>
        </div>
        <Button size="sm" className="bg-emerald-brand hover:bg-emerald-hover" onClick={handleSave} disabled={saving}>
          {saving ? <RefreshCw className="h-4 w-4 animate-spin mr-2" /> : null}
          Save Settings
        </Button>
      </CardContent>
    </Card>
  );
}
